import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_CREATE_CLASS_ROOM,
  ENDPOINT_EDIT_CLASS_ROOM,
  ENDPOINT_FIND_MANAGER_BY_ID_UF,
  ENDPOINT_GET_CLASS_ROOM,
  ENDPOINT_GET_CLASS_ROOM_ID,
  ENDPOINT_GET_COMPLETE_DATA_ITEM,
  ENDPOINT_INTERVIEWS,
  ENDPOINT_LINK_INTERVIEW_TO_CLASS_ROOM,
  ENDPOINT_LIST_CLASS_ROOM,
  ENDPOINT_SAVE_COMMENT,
  ENDPOINT_SYNC_CLASS_FOCO,
} from './constants';

export function useManageClassService() {
  const { backendPost, backendGet, backendPatch, backendPut } =
    Sebrae.useBackend();

  const createClassRoom = React.useCallback(
    (data) => backendPost(`${ENDPOINT_CREATE_CLASS_ROOM}`, data),
    [backendPost],
  );

  const createComment = React.useCallback(
    (textComment, id) =>
      backendPost(`${ENDPOINT_SAVE_COMMENT}?idInterview=${id}`, {
        textComment,
      }),
    [backendPost],
  );

  const getInterviewComments = React.useCallback(
    (id) => backendGet(`${ENDPOINT_INTERVIEWS}/${id}/comments`),
    [backendGet],
  );

  const toggleClass = React.useCallback(
    (id) =>
      backendPatch(`${ENDPOINT_CREATE_CLASS_ROOM}/${id}/toggle-class-room`),
    [backendPatch],
  );

  const getListInteresedClass = React.useCallback(
    (id) => backendGet(`${ENDPOINT_LIST_CLASS_ROOM}/${id}/simple-data`),
    [backendGet],
  );

    const syncClassFoco = React.useCallback(
    () => backendGet(`${ENDPOINT_SYNC_CLASS_FOCO}`),
    [backendGet],
  );

  const getSimpleListClass = React.useCallback(
    (id, filter) =>
      backendGet(`${ENDPOINT_LIST_CLASS_ROOM}/${id}/simple-data`, { filter }),
    [backendGet],
  );

  const getManagerbYiDuF = React.useCallback(
    (filter) => backendGet(`${ENDPOINT_FIND_MANAGER_BY_ID_UF}/`, { ...filter }),
    [backendGet],
  );

  const getcolumns = React.useCallback(
    ({ params, id }) =>
      backendGet(`${ENDPOINT_GET_CLASS_ROOM}/${id}/board-columns`, {
        ...params,
      }),
    [backendGet],
  );

  const getcolumnsDefault = React.useCallback(
    (id, params) =>
      backendGet(`${ENDPOINT_GET_CLASS_ROOM}/${id}/board-columns`, {
        ...params,
      }),
    [backendGet],
  );

  const getSimpleBoardItems = React.useCallback(
    ({ params, idModule }) =>
      backendGet(`${ENDPOINT_GET_CLASS_ROOM}/${idModule}/simple-board-items`, {
        ...params,
      }),
    [backendGet],
  );

  const getCompleteBoardItems = React.useCallback(
    (idInterview) =>
      backendGet(
        `${ENDPOINT_GET_COMPLETE_DATA_ITEM}/${idInterview}/complete-board-item`,
      ),
    [backendGet],
  );
  const patchInterviewToClass = React.useCallback(
    (data) => backendPatch(`${ENDPOINT_LINK_INTERVIEW_TO_CLASS_ROOM}`, data),
    [backendPatch],
  );

  const getClassRoomById = React.useCallback(
    (idClassRoom) => backendGet(`${ENDPOINT_GET_CLASS_ROOM_ID}/${idClassRoom}`),
    [backendGet],
  );

  const editClassRoomId = React.useCallback(
    (idClassRoom, data) =>
      backendPut(`${ENDPOINT_EDIT_CLASS_ROOM}/${idClassRoom}`, data),
    [backendPut],
  );

  return {
    createClassRoom,
    getcolumns,
    getSimpleBoardItems,
    getCompleteBoardItems,
    patchInterviewToClass,
    createComment,
    getInterviewComments,
    getcolumnsDefault,
    getListInteresedClass,
    getSimpleListClass,
    getClassRoomById,
    editClassRoomId,
    toggleClass,
    getManagerbYiDuF,

    syncClassFoco
  };
}
